var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8380_75519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3417 4.60623C15.3417 5.46833 16.6783 5.46833 16.6783 4.60623C16.6783 3.74413 15.3417 3.74413 15.3417 4.60623ZM14.0051 4.60623C14.0051 2.01993 18.0149 2.01993 18.0149 4.60623C18.0149 7.19254 14.0051 7.19254 14.0051 4.60623Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0101 21.3135C18.1955 21.3135 20.0199 23.1379 20.0199 25.3233C20.0199 27.5086 18.1955 29.333 16.0101 29.333C13.8248 29.333 12.0004 27.5086 12.0004 25.3233C12.0004 23.1379 13.8248 21.3135 16.0101 21.3135Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2768 20.7787C28.9075 22.4428 27.6778 25.3231 25.3655 25.3231H6.65323C4.32756 25.3231 3.12463 22.4294 4.7419 20.7787C5.96488 19.529 6.65323 17.8516 6.65323 16.1007V13.9621C6.65323 8.863 10.9103 4.60596 16.0094 4.60596C21.1085 4.60596 25.3655 8.863 25.3655 13.9621V16.1007C25.3662 17.8516 26.0539 19.529 27.2768 20.7787Z",
    fill: "#F9BF2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5076 8.26892C13.2427 7.81448 13.9444 8.95726 13.2093 9.40502C12.2202 10.0132 11.4517 10.9287 11.0307 12.0114C10.7166 12.8133 9.47352 12.3322 9.78762 11.5235C10.3162 10.1736 11.2719 9.03078 12.5076 8.26892Z",
    fill: "#0E0F10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8380_75519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.b89a24d776d147dea73fd7e6c3ca11c4.svg";
export { ForwardRef as ReactComponent };